import {ObvioEvent} from 'Event'
import {
  ObieAttendeeLink,
  ObieAttendeeLinkData,
  ObieAttendeeLinkError,
} from 'lib/event-api/integrations/obie/attendee-links/list'
import {Client} from 'lib/ui/api-client'
import {api} from 'lib/url'
import {useMutation, useQueryClient} from 'react-query'

export function useUpdateObieAttendeeLink(params: {
  client: Client
  event: ObvioEvent
  link: ObieAttendeeLink
}) {
  const {client, event, link} = params
  const qc = useQueryClient()

  return useMutation<
    ObieAttendeeLink,
    ObieAttendeeLinkError,
    ObieAttendeeLinkData
  >({
    mutationFn: (data) =>
      client.put<ObieAttendeeLink>(
        api(`/events/${event.id}/integrations/obie/attendee_links/${link.id}`),
        data,
      ),
    onSuccess: (updated) => {
      qc.setQueryData<ObieAttendeeLink[]>(
        ['events', event.id, 'integrations', 'obie', 'attendee_links'],
        (links) => {
          if (!links) {
            return [updated]
          }

          return links.map((current) => {
            if (current.id === updated.id) {
              return updated
            }

            return current
          })
        },
      )
    },
  })
}
